import { LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { IGroup } from '../../../data/models/Entities';
import { _DICT_ESCUELAS, _SvEscuelaObtenerConfiguracionByEscuela } from '../../../data/services/Escuela';
import "./GroupAvatar";

@customElement('app-groups-view')
export class GroupsView extends LitElement {
    static styles = css`
        :host { display:block; }
        .grid { display:flex; flex-wrap:wrap; padding: 0px 15px; gap:12px; align-items:flex-start }
        .school-block { margin-bottom: 24px; }
    `;

    @state() private groupMapping: Map<number, IGroup[]> = new Map();

    private _groups: IGroup[] | null = null;

    set groups(value: IGroup[]) {
        this._groups = value;

        const groupMapping = new Map<number, IGroup[]>();

        (value || []).forEach(group => {
            const escuelaId = group.IdEscuela || 0;
            if (!groupMapping.has(escuelaId)) groupMapping.set(escuelaId, []);
            groupMapping.get(escuelaId)!.push(group);
        });
        groupMapping.forEach((_, escuelaId) => {
            if (!_DICT_ESCUELAS.has(escuelaId)) {
                _SvEscuelaObtenerConfiguracionByEscuela(escuelaId, () => {
                    this.requestUpdate();
                });
            }
        });

        this.groupMapping = groupMapping;
    }

    get groups(): IGroup[] {
        return this._groups;
    }

    render() {
        return html`
            ${Array.from(this.groupMapping.entries()).map(([escuelaId, groups]) => html`
                <section class="school-block">
                    <h3 class="school-title">${_DICT_ESCUELAS.get(escuelaId)?.Nombre || ''}</h3>
                    <div class="grid">
                        ${groups.map(g => html`
                        <app-group-avatar .group=${g} @click=${(e) => this.onGroupSelect(e, g)}></app-group-avatar>
                        `)}
                    </div>
                </section>
            `)}
        `;
    }

    private onGroupSelect(e: Event, group: IGroup) {
        if (this["__click"]) return;
        this["__click"] = true;

        (e.currentTarget as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        setTimeout(() => {
            this.dispatchEvent(new CustomEvent('group-select', { detail: group, bubbles: true, composed: true }));
            this["__click"] = false;
        }, 200);
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'app-groups-view': GroupsView;
    }

    interface HTMLElementEventMap {
        'group-select': CustomEvent<IGroup>;
    }
}